import { FormControl, FormHelperText, Typography } from '@material-ui/core'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Link from '@material-ui/core/Link'
import TextField from '@material-ui/core/TextField'
import BtnEndIcon from '@material-ui/icons/KeyboardArrowRight'
import React, { FormEvent, FormEventHandler, useEffect, useState } from 'react';
import { useStyles } from './_Styles'
import { useHistory } from 'react-router'
import chatApi from '../../../api/chatApi'
import { useAsyncFn } from 'react-use'
import ButtonWithProgress from '../../common/ButtonWithProgress'
import { ToastNotification } from '@carbon/react';

interface RegistrationFormInterface {
  changeIsError?: () => void
  changeStateSuccess?: () => void
}

export default function RegistrationForm({ changeIsError, changeStateSuccess }: RegistrationFormInterface) {
  const classes = useStyles()
  const hasError = false
  const [emailField, setEmailField] = useState<string>('')
  const [passField, setPassField] = useState<string>('')
  const [isCheckbox, setIsCheckbox] = useState(false)
  const [isPasswordError, setIsPasswordError] = useState(false)
  const [btnBlock, setIsBlock] = useState(false)
  const [errorText, setErrorText] = useState('')

  const history = useHistory()

  const [{ loading: isSending }, doRegistration] = useAsyncFn(() => {
    return chatApi
      .registration({
        email: emailField,
        password: passField,
        login: emailField
      })
      .then(res => {
       setTimeout(() => history.replace('/login'), 6000)
       changeStateSuccess()
      })
      .catch(err => {
        console.log(err);
        changeIsError()
      })
  }, [emailField, passField])

  const onSubmit: FormEventHandler = async (event: FormEvent) => {
    event.preventDefault()
    await doRegistration()
  }

  const cyrillicRegExp = /^[^а-яА-ЯёЁ]+$/

  useEffect(() => {
    checkCyrillic(emailField)
    checkCyrillic(passField)

    if(emailField.length > 0 && passField.length >= 8) {
      setErrorText('Логин и Пароль не должны содержать кириллицу. Пароль должен содержать не менее 8 символов')
    }

    if(passField.length < 8) {
      setErrorText('Пароль должен содержать больше 8 символов')
    }

    if(emailField.length === 0) {
      setErrorText('Логин не может быть пустым')
    }

  }, [emailField, passField, isCheckbox])

  function changeEmailHandler(value: string) {
    setEmailField(value)
  }

  function changePasswordHandler(value: string) {
    setPassField(value)
  }

  function changeCheckboxHandler(value: boolean) {
    setIsCheckbox(value)
  }

  function checkCyrillic (value) {
    let timer = null

    if (!cyrillicRegExp.test(value) || !cyrillicRegExp.test(emailField) || !cyrillicRegExp.test(passField)) {
      setIsPasswordError(true)
      setIsBlock(true)
      timer = setTimeout(() => {
        setIsPasswordError(false);
        clearInterval(timer)
      }, 5000)
    } else {
      setIsBlock(false)
      setIsPasswordError(false)
    }

  }

  return (
    <div className={classes.paper}>
      {
        isPasswordError &&
        <div style={{ position: 'fixed', top: 100, right: 0, zIndex: 1000 }}>
          <ToastNotification
            kind="error"
            hideCloseButton={false}
            lowContrast={false}
            iconDescription="При обновлении данных произошла ошибка"
            subtitle={
              <span>{errorText}</span>
            }
            timeout={5000}
            title="Ошибка"
          />
        </div>
      }
      <form className={classes.form} onSubmit={onSubmit}>
        <TextField
          value={emailField}
          onChange={e => changeEmailHandler(e.target.value)}
          error={hasError}
          disabled={isSending}
          type='email'
          label='Email'
          className={classes.input}
          autoComplete={'new-password'}
          helperText={hasError ? 'Неверно введен email' : ''}
          fullWidth
        />
        <TextField
          value={passField}
          disabled={isSending}
          onChange={e => changePasswordHandler(e.target.value)}
          error={hasError}
          type='password'
          autoComplete={'new-password'}
          label='Пароль'
          className={classes.input}
          helperText={hasError ? 'Пароль должен быть длиннее 8 символов' : ''}
          fullWidth
        />
        <FormControl
          required
          error={hasError}
          disabled={isSending}
          fullWidth
          className={classes.checkbox}
        >
          <FormControlLabel
            control={
              <Checkbox
                onChange={() => changeCheckboxHandler(!isCheckbox)}
                value={isCheckbox}
                color='primary'
                aria-describedby='component-error-text'
              />
            }
            label={
              <Typography variant='caption'>
                Я согласен с <Link href='#'>правилами</Link>
              </Typography>
            }
          />
          {hasError && (
            <FormHelperText id='component-error-text'>
              Необходимо согласиться с правилами
            </FormHelperText>
          )}
        </FormControl>
        <div style={{display: 'flex', flexDirection: 'column', gap: 15, alignItems: 'center'}} className={classes.submitWrapper}>
          <ButtonWithProgress
            variant='contained'
            color='primary'
            type='submit'
            disabled={
              btnBlock ||
              isSending ||
              !isCheckbox ||
              passField.length < 8
          }
            loading={isSending}
            endIcon={<BtnEndIcon />}
          >
            РЕГИСТРАЦИЯ
          </ButtonWithProgress>
          <ButtonWithProgress
            variant='contained'
            color='primary'
            type='submit'
            disabled={isSending}
            loading={isSending}
            endIcon={<BtnEndIcon />}
            onClick={() => history.replace('/login')}
          >
            АВТОРИЗАЦИЯ
          </ButtonWithProgress>
        </div>
      </form>
    </div>
  )
}
